import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { CommunityReplyRemoveasyncReqPros, CommunityReplyRemoveInitialState } from "../model/CommunityReplyRemoveReducerType";

const reducerId = "CommunityReplyRemoveReducer/asyncReqCommunityReplyRemove";
const controllerMap = new Map();

const initialState: CommunityReplyRemoveInitialState = {
    status: "",
    n4ErrorCode: 0,
    strErrorMessage: "",
    isSuccess: false,
    INFO: undefined
};

const slice = createSlice({
    name: "CommunityReplyRemoveReducer",
    initialState,
    reducers: {
        setInitStatus: (state) => {
            state.status = "";
        }
    },
    extraReducers: (builder) => {
        builder.addCase(asyncReqCommunityReplyRemove.pending, (state) => {
            state.status = "LOADING";
        });
        builder.addCase(asyncReqCommunityReplyRemove.fulfilled, (state, action) => {
            state.status = "COMPLETE";
            state.n4ErrorCode = action.payload.n4ErrorCode;
            state.strErrorMessage = action.payload.strErrorMessage;
            state.isSuccess = action.payload.isSuccess;
            state.INFO = action.payload.INFO;
        });
        builder.addCase(asyncReqCommunityReplyRemove.rejected, (state, action) => {
            if (action.payload?.aborted) return; // 'AbortError'로 인한 취소라면 상태 변경하지 않음
            state.status = "FAIL";
        });
    }
});

type RejectPayload = { aborted: boolean; message?: string };

export const asyncReqCommunityReplyRemove = createAsyncThunk<
        any, // 성공 시 반환 타입 (API 응답 타입)
        CommunityReplyRemoveasyncReqPros, // thunk 파라미터 타입
        {
            rejectValue: RejectPayload; // ❗ rejectWithValue 타입 명시
        }
    >(
    reducerId,
    async ({ comment_seq }: CommunityReplyRemoveasyncReqPros, thunkAPI) => {
        // 이전 요청이 있으면 취소
        const prevController = controllerMap.get(reducerId);
        if (prevController) prevController.abort();

        // 새 요청용 controller 생성
        const controller = new AbortController();
        controllerMap.set(reducerId, controller);

        try {
            const res = await fetch(`${process.env.REACT_APP_API_DOMAIN}/ApiReact/CommunityReplyRemove.aspx?comment_seq=${encodeURIComponent(comment_seq)}`,
                {
                    signal: controller.signal,
                }
            );
            const data = await res.json();
            return data;
        }
        catch (error: any) {
            // ❗ AbortError인 경우는 구분해서 처리
            if (error.name === "AbortError") {
                return thunkAPI.rejectWithValue({ aborted: true });
            }
            return thunkAPI.rejectWithValue({ aborted: false, message: error.message });
        }
    }
);

export const CommunityReplyRemoveActions = slice.actions;
export default slice.reducer;